import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import styles from "./LeadTimes.module.scss";
import CheckBox from "../../../shared/checkBox/CheckBox";
import { TextField, Tooltip } from "@mui/material";
import { withTranslation } from "react-i18next";
import InfoTooltip from "./InfoTooltip";

function CellValue({ value }) {
  return value ? (value.trim().length === 0 ? "-" : value) : "-";
}

function getInputValue(inputValue) {
  return inputValue ? (inputValue.trim().length === 0 ? "" : inputValue) : "";
}

function LeadTimesRow(props) {
  const [isClient, setIsClient] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const { deliveryStatus } = props.data;

  useEffect(() => {
    setIsClient(true);
  }, []);

  function validateLeadTime(value) {
    if (!value || value.trim() === '') return false;

    const regex = /^[0-9][0-9]-[0-9][0-9]$/;
    if (!regex.test(value)) return false;

    const parts = value.split('-');
    const first = parseInt(parts[0]);
    const second = parseInt(parts[1]);

    return first < second;
  }

  function handleFieldChange(e, key) {
    const value = e.target.value;
    const fieldKey = `${key}${props.index}`;
    const isValid = validateLeadTime(value);

    setFieldErrors(prev => ({
      ...prev,
      [fieldKey]: !isValid && value.length > 0
    }));

    if (value.length === 5) {
      if (!isValid) {
        e.target.setCustomValidity(props.t("Error.invalid"));
      } else {
        e.target.setCustomValidity("");
      }
    }

    props.handleChange(e, props.index, key);
  }

  function getTextField(key) {
    if (!isClient) {
      return <CellValue value={deliveryStatus[key]} />;
    }

    const fieldKey = `${key}${props.index}`;
    const hasError = fieldErrors[fieldKey];
    const value = getInputValue(deliveryStatus[key]);

    return (
      <Tooltip
        title={<InfoTooltip {...props} />}
        placement="top"
        open={
          props.index === 0 &&
          props.infoTooltipOpen &&
          props.infoTooltipColumn === key
        }
        disableHoverListener={true}
        disableFocusListener={true}
        disableTouchListener={true}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "white",
              color: "black",
              boxShadow: "1px 1px 9px 0 rgba(0, 0, 0, 0.27)",
              border: "1px solid #ccc",
              fontSize: "14px",
            },
          },
          arrow: {
            sx: {
              color: "white",
            },
          },
        }}
      >
        <TextField
          className={styles.leadTimesInput}
          variant="outlined"
          name={fieldKey}
          data-testid={fieldKey}
          value={value}
          placeholder="XX-XX"
          required
          error={hasError}
          helperText={hasError ? props.t("Error.invalid") : ""}
          inputProps={{
            pattern: "[0-9][0-9]-[0-9][0-9]",
            maxLength: 5
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              boxShadow: 'none !important',
              '&:hover': {
                boxShadow: 'none !important',
              },
              '&.Mui-focused': {
                boxShadow: 'none !important',
              },
              '& input': {
                boxShadow: 'none !important',
                '&:-webkit-autofill': {
                  boxShadow: 'none !important',
                  backgroundColor: 'transparent !important',
                },
              },
            },
          }}
          onKeyDown={(e) => props.handleKeyDown(e)}
          onChange={(e) => handleFieldChange(e, key)}
          onInvalid={(e) => {
            e.target.setCustomValidity(props.t("Error.invalid"));
          }}
          onInput={(e) => {
            if (e.target.value.length < 5) {
              e.target.setCustomValidity("");
            }
          }}
        />
      </Tooltip>
    );
  }

  let modelName = `${props.data.factoryNumber}/${props.data.model}`;
  modelName = props.data.series
    ? `${modelName}/${props.data.series}`
    : modelName;

  return (
    <Grid
      container
      spacing={0}
      className={props.firstLoad ? styles.redRow : styles.row}
    >
      <Grid item xs={1} className={styles.checkDiv}>
        {props.firstLoad && (
          <div data-testid="warning" className={styles.warning}></div>
        )}
        {props.data.saved && (
          <div data-testid="saved" className={styles.saved}></div>
        )}
        <div className={styles.checkbox}>
          <CheckBox
            id={props.index}
            faded={true}
            checked={props.data.checked}
            isDisabled={true}
          />
        </div>
      </Grid>
      <Grid item xs={5} className={styles.descriptionRow}>
        {modelName}
      </Grid>
      <Grid item xs={1} className={styles.editRow}>
        {props.editModeAtYard ? (
          getTextField("AtYard")
        ) : (
          <CellValue value={deliveryStatus.AtYard} />
        )}
      </Grid>

      <Grid item xs={1} className={styles.editRow}>
        {props.editModeProducedInTransit ? (
          getTextField("ProducedInTransit")
        ) : (
          <CellValue value={deliveryStatus.ProducedInTransit} />
        )}
      </Grid>

      <Grid item xs={1} className={styles.editRow}>
        {props.editModeOrderScheduling ? (
          getTextField("OrderScheduling")
        ) : (
          <CellValue value={deliveryStatus.OrderScheduling} />
        )}
      </Grid>
    </Grid>
  );
}

export default withTranslation("emp")(LeadTimesRow);
